import CookiesBannerContextProvider, { useCookiesBannerContext } from './CookiesBannerContext';

export { useCookiesBannerContext };
export default CookiesBannerContextProvider;
